import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTabNavigation } from 'src/redux/slices/navigation/hooks'
import { ContextLayersConfig } from 'src/redux/slices/umibuilder/consts'
import { setContextLayer } from 'src/redux/slices/umibuilder/reducers'
import { selectContextLayers } from 'src/redux/slices/umibuilder/selectors'
import { getEntries } from 'src/redux/utils'
import { TextFieldOnChangeEvent } from 'src/types/event-handlers'

import { Button, FormControlLabel, Grid, Switch } from '@material-ui/core'

///// Component
const ContextLayersPage: React.FC = () => {
  const dispatch = useDispatch()
  const { goToTab } = useTabNavigation()
  const contextLayers = useSelector(selectContextLayers)

  const updateLayer = useCallback(
    (e: TextFieldOnChangeEvent, value: boolean) => {
      dispatch(setContextLayer({ layer: e.target.id as keyof typeof ContextLayersConfig, value }))
    },
    [dispatch],
  )

  const advanceToExport = useCallback(() => {
    goToTab('export')
  }, [goToTab])

  return (
    <>
      <Grid container justifyContent='center'>
        {getEntries(contextLayers).map(([layer, value]) => (
          <FormControlLabel
            key={`context-layer-toggle-${layer}`}
            control={<Switch id={layer} onChange={updateLayer} checked={value} color='primary' />}
            label={ContextLayersConfig[layer]?.label}
          />
        ))}
      </Grid>

      <Grid container justifyContent='center'>
        <Button onClick={advanceToExport} variant='contained' color='primary'>
          Confirm
        </Button>
      </Grid>
    </>
  )
}

export default ContextLayersPage
